// extracted by mini-css-extract-plugin
export default {"maincontainer":"Resume_maincontainer__tODNZ","imagecontainer":"Resume_imagecontainer__W-t2t","image":"Resume_image__Z4vl5"};